<template>
  <div>
    <b-input-group>
      <b-form-input
        id="input_customer"
        size="sm"
        :disabled="this.$props.isDisabled"
        v-model="query"
        placeholder="Сотрудник"
        autocomplete="off"
        @focus="onFocusIn"
        @blur="onFocusOut"/>

      <b-input-group-append>
        <b-button size="sm" :disabled="!query || this.$props.isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-input-user" v-if="isFocus">
        <b-list-group-item
          v-for="(item, index) in items"
          :key="index"
          @mousedown="onClick(item)"
          button
          class="text-small"
        >
          <p class="m-0 p-0">{{item.name}}</p>
          <p class="m-0 p-0 text-secondary">{{item.role_name}}</p>
        </b-list-group-item>
      </b-list-group>
    </b-input-group>
  </div>
</template>

<script>
import users from "../../network/users";

export default {
  name: "UserSelect",
  mixins: [ users ],
  props: {
    isDisabled: Boolean,
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      location_id: 0,
      location_position: null
    }
  },
  methods: {
    async configure(id, locationId, locationPosition) {
      if (locationId != null) {
        this.location_id = locationId;
      }

      this.location_position = locationPosition;

      if (id > 0) {
        const user = (await this.getUserById(id)).data;
        if (user != null) {
          this.query = user.name;
          return;
        }
      }

      this.query = "";

      this.items = await this.getItems();
    },
    onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    onClear() {
      this.query = "";
      this.$emit('onSelect',0);
    },
    onClick(item) {
      this.query = item.name;
      this.$emit('onSelect',item.id, item.name);
    },
    async getItems() {
      const data = {
        page: 1,
        size: 400,
        query: this.query.toLowerCase(),
        locationId: this.location_id,
        locationPositionId: this.location_position,
      }

      const result = await this.getUsersSearch(data);

      return result.data != null ? result.data.items : [];
    }
  },
  watch: {
    'query': {
      handler: async function () {
        if (this.query != null) {
          this.items = await this.getItems();
        }
      }, deep: true, immediate: true
    },
  }
}
</script>

<style>
.autocomplete-input-user {
  max-height: 250px;
  margin-top: 31px;
  min-width: 100%;
  overflow-y: auto;
  position: absolute;
  z-index: 1000;
}

.autocomplete-input-user .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/UserSelect.vue